<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="480px"
    custom-class="ca-login-dialog"
  >
    <div class="ca-login-dialog__head">
      <h3 class="ca-login-dialog__title">手机验证码登录</h3>
      <p class="ca-login-dialog__subtitle">提交订单前请先完成登录</p>
    </div>
    <div class="ca-login-dialog__body">
      <el-form ref="form" :model="form" :rules="rules" @submit.native.prevent>
        <el-form-item prop="mobile">
          <el-input v-model="form.mobile" placeholder="请输入手机号" maxlength="11" />
        </el-form-item>
        <el-form-item prop="code">
          <div class="ca-login-dialog__code-row">
            <el-input v-model="form.code" placeholder="请输入验证码" maxlength="6" />
            <el-button
              class="ca-login-dialog__send-btn"
              :disabled="countdown > 0 || sending"
              @click="handleSendCode"
            >
              {{ countdown > 0 ? countdown + 's' : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>
        <!-- 验证码即注册：未注册手机号验证通过后自动建号 -->
        <p class="ca-login-dialog__tip">未注册的手机号验证通过后将自动创建账号</p>
        <el-button
          type="danger"
          class="ca-login-dialog__submit"
          :loading="submitting"
          @click="handleLogin"
        >
          登 录
        </el-button>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { REGEXP } from '../util/caForm'
import { sendCode } from '@/api/user'

export default {
  name: 'CaLoginDialog',
  data() {
    return {
      form: { mobile: '', code: '' },
      rules: {
        mobile: [{ pattern: REGEXP.mobile, message: '请输入正确的手机号', trigger: 'blur' }],
        code: [{ pattern: /^\d{4,6}$/, message: '请输入验证码', trigger: 'blur' }],
      },
      countdown: 0,
      timer: null,
      sending: false,
      submitting: false,
    }
  },
  computed: {
    // 弹框可见性绑定主站共享的 user/loginVisible：401 拦截器、showLogin()、
    // 「去结算未登录」均写同一 flag 触发弹框；登录成功后 login action 会
    // commit SET_LOGINVISIBLE false，弹框自动关闭。
    dialogVisible: {
      get() {
        return this.$store.state.user.loginVisible
      },
      set(v) {
        this.$store.commit('user/SET_LOGINVISIBLE', v)
      },
    },
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    // 发送成功后开始 60s 倒计时，期间禁止重复获取验证码
    startCountdown() {
      this.countdown = 60
      this.clearTimer()
      this.timer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown <= 0) this.clearTimer()
      }, 1000)
    },
    handleSendCode() {
      if (!REGEXP.mobile.test(this.form.mobile)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      this.sending = true
      sendCode({ mobile: this.form.mobile })
        .then(() => this.startCountdown())
        .finally(() => {
          this.sending = false
        })
    },
    handleLogin() {
      this.$refs.form.validate((valid) => {
        if (!valid) return
        this.submitting = true
        this.$store
          .dispatch('user/phoneLogin', {
            phone: this.form.mobile,
            code: this.form.code,
            checkLoginStatus: false,
          })
          .then(() => {
            // login action 已 commit SET_LOGINVISIBLE false → 弹框自动关闭，停留在当前页
            this.form.code = ''
          })
          .finally(() => {
            this.submitting = false
          })
      })
    },
  },
}
</script>
